import Loading from "components/Loading";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from 'react'
import { toast } from "react-toastify";
import { getInvestmentOpportunityDashboard } from "services/investmentOpportunity.routes";
import InvestmentDashboardItem from "./InvestmentDashboardItem";
import InvestmentTransactionsModal from "./InvestmentTransactionsModal";
import useModal from "hooks/useModal";

export default function InvestmentDashboard() {
    const [loading, setLoading] = useState(false)
    const [investmentDashboard, setInvestmentDashboard] = useState([])
    const [modals, updateModal, closeInsideModal] = useModal({
        investmentTransactions: { state: false },
    });
    const closeInvestmentTransactionsModal = () => closeInsideModal("investmentTransactions");

    console.log(modals.investmentTransactions)
    useEffect(() => {
        setLoading(true);
        getInvestmentOpportunityDashboard((isOk, data) => {
            setLoading(false);
            if (!isOk) {
                return toast.error(data.message)
            } else {
                setInvestmentDashboard(data);
            }
        })
    }, []);

    const handleOpenInvestmentTransaction = (investmentId) => {
        updateModal("investmentTransactions", { state: true, investmentId: investmentId });
    }
    return (
        <DashboardLayout>
            <Loading loading={loading} />
            <DashboardNavbar />
            <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 20 }}>
                {investmentDashboard.map(item => <InvestmentDashboardItem key={item.investment_opportunity_id} item={item} handleOpenInvestmentTransaction={handleOpenInvestmentTransaction} />)}
            </div>
            {modals.investmentTransactions.state && <InvestmentTransactionsModal modalInfo={modals.investmentTransactions} closeModal={closeInvestmentTransactionsModal} />}
        </DashboardLayout>
    )
}
